import { render } from "./TemplateStyleEditor.vue?vue&type=template&id=1e635851&scoped=true"
import script from "./TemplateStyleEditor.vue?vue&type=script&lang=js"
export * from "./TemplateStyleEditor.vue?vue&type=script&lang=js"

import "./TemplateStyleEditor.vue?vue&type=style&index=0&id=1e635851&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e635851"]])

export default __exports__